'use strict';

(function ($) {
  var NAMESPACE = 'check-all';

  $.fn.checkAll = function () {
    return this.each(function () {
      var $this = $(this),
        $masterCheckbox = $this.find('[data-' + NAMESPACE + '=master]'),
        $slaveCheckboxes = $this.find('[data-' + NAMESPACE + '=slave]'),
        $count = $this.find('[data-' + NAMESPACE + '=count]'),
        checked = 0;

      init();

      function hasBulkButton() {
        var bulkButton = $this.find('[data-' + NAMESPACE + '=count]');
        return bulkButton.length > 0;
      }

      function hasCount() {
        return $count.length > 0;
      }

      function init() {
        updateAll();
        bindEvents();
      }

      function bindEvents() {
        $masterCheckbox.on('change.checkAll', function () {
          updateAll();
        });

        $slaveCheckboxes.on('change.checkAll', function () {
          updateCheckbox(this);
        });
      }

      function updateCount(isChecked) {
        if (checked === 0) {
          $count.hide();
        } else {
          $count.show();
        }

        $count.html(checked);
      }

      function count(isChecked) {
        if (isChecked) {
          ++checked;
        } else if (checked > 0) {
          --checked;
        }
      }

      function updateButton() {
        var $button = $this.find('[data-' + NAMESPACE + '=button]'),
          disabled;

        if (checked === 0) {
          disabled = true;
        } else {
          disabled = false;
        }

        $button.prop('disabled', disabled);
      }

      function updateAll() {
        var $enabledCheckboxes = $slaveCheckboxes.not(':disabled'),
          isChecked = $masterCheckbox.is(':checked');

        $enabledCheckboxes.prop('checked', isChecked);

        if (hasCount()) {
          checked = $enabledCheckboxes.filter(':checked').length;
          updateCount(isChecked);
        }

        if (hasBulkButton()) {
          updateButton();
        }
      }

      function updateCheckbox(checkbox) {
        var isChecked = checkbox.checked;

        if (hasCount()) {
          count(isChecked);
          updateCount(isChecked);
        }

        if (hasBulkButton()) {
          updateButton();
        }

        updateMaster();
      }

      function updateMaster() {
        if ($slaveCheckboxes.filter(':checked').length === 0) {
          $masterCheckbox.prop('checked', false);
        } else if (!$masterCheckbox.is(':checked')) {
          $masterCheckbox.prop('checked', true);
        }
      }
    });
  };

  $(function () {
    $('[data-plugin=' + NAMESPACE + ']').checkAll();
  });
})(jQuery);




// WEBPACK FOOTER //
// ./javascripts/components/legacy/plugins/jquery.check-all.js